import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import {
  SCHEDULING_TASKS_ENDPOINTS,
  SCHEDULING_TASKS_URL,
} from 'SharedDir/backend/endpoints/scheduling-tasks';
import { Paginated, PaginationParams } from 'SharedDir/declarations/pagination';
import {
  Schedule,
  ScheduledTaskBare,
  ScheduledTaskCreate,
  ScheduledTaskFull,
  ScheduledTaskTypeList,
} from 'SharedDir/declarations/scheduling-tasks';

export default class SchedulingTasksApiClass extends SimpleApi<
  ScheduledTaskBare,
  ScheduledTaskCreate
> {
  constructor() {
    super(SCHEDULING_TASKS_URL);
  }

  protected readonly endpoints = SCHEDULING_TASKS_ENDPOINTS;

  public async getTypes() {
    const endpoint = this.endpoints.TYPES;
    const { data } = (await http(endpoint)) as AxiosResponse<ScheduledTaskTypeList>;
    return data;
  }

  public async getSchedules<Extra extends object>(id: number, params: PaginationParams<Extra>) {
    const endpoint = this.endpoints.SCHEDULES(id);
    const { data } = (await http({ ...endpoint, params })) as AxiosResponse<
      Paginated<Schedule, Extra>
    >;
    return data;
  }

  public async disable(id: number) {
    const endpoint = this.endpoints.DISABLE(id);
    const { data } = (await http(endpoint)) as AxiosResponse<ScheduledTaskFull>;
    return data;
  }

  public async enable(id: number) {
    const endpoint = this.endpoints.ENABLE(id);
    const { data } = (await http(endpoint)) as AxiosResponse<ScheduledTaskFull>;
    return data;
  }

  public async run(id: number) {
    const endpoint = this.endpoints.RUN(id);
    const { data } = (await http(endpoint)) as AxiosResponse<ScheduledTaskFull>;
    return data;
  }

  public async stop(id: number) {
    const endpoint = this.endpoints.STOP(id);
    const { data } = (await http(endpoint)) as AxiosResponse<ScheduledTaskFull>;
    return data;
  }
}
